var cartObj = {
    route: {
        change: "/cart/change.js",
        add: "/cart/add.js",
        clear: "/cart/clear.js",
        update: "/cart/update.js",
        getCart: "/cart.js"
    },
    product: {
        button: ".js-product-button",
        backinStockWrapper: ".js-product-bis",
        video: ".js-product-video",
        option: ".js-product-option",
        prices: ".js-product-prices",
        unavailable: ".js-product-unavailable",
        recommendations: ".js-product-recommendations",
        currentPrice: ".js-product-price",
        comparePrice: ".js-product-compare-price",
        unavailableClass: "is-unavailable",
        statusMessageElem: document.querySelector(".js-product-status-message"),
        backorderAllElem: document.querySelector(".js-product-backorder-all"),
        futureFilterVariantId: null,
        map: null,
        backorderDate: null,
        backorderMessage: null,
        backorderArray: null,
        interacted: !1,
        currentVariantId: null,
        subscribe: {
            selected: !1,
            discountMultiplier: 1
        }
    }
};

function setCookie(name, value, expirationDays) {
    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expirationDays);

    var cookie = name + "=" + value + "; expires=" + expirationDate.toUTCString() + "; path=/";
    document.cookie = cookie;
}

function setJsonCookie(name, jsonObj, expireDays) {
    var jsonStr = JSON.stringify(jsonObj);

    var expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + expireDays);

    var cookie = name + "=" + jsonStr + "; expires=" + expireDate.toUTCString() + "; path=/";
    document.cookie = cookie;
}

function getJsonCookie(name) {
   return new Promise((resolve,reject) => {
      var cookieName = name + "=";
      var cookies = document.cookie.split(';');

      for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i].trim();
          if (cookie.indexOf(cookieName) === 0) {
              var jsonStr = decodeURIComponent(cookie.substring(cookieName.length, cookie.length));
              resolve (JSON.parse(jsonStr));
          }
      }

      reject(null);
   });
}

function removeAllCartCookies(){
  return new Promise((resolve, reject) => {
    const cookies = document.cookie.split(';');
    if(!cookies.length) reject('Nothing to remove');
    for(let i = 0; i < cookies.length; i++) {
      const trimedCookie = cookies[i].trim();
      if(!trimedCookie.includes('_recharge_properties_')) continue;
      const cookie = cookies[i].split('=');
      const removedCookie = `${cookie[0]}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = removedCookie;
    }
    resolve('All recharge cookies removed');
  });
}

function addMonthToDate(monthsToAdd) {
	var currentDate = new Date();
	currentDate.setMonth(currentDate.getMonth() + Number(monthsToAdd));

	var day = currentDate.getDate();
	var month = currentDate.getMonth() + 1;
	var year = currentDate.getFullYear();

	// Ensure correct formatting for single-digit days and months
	var formattedDay = day < 10 ? '0' + day : day;
	var formattedMonth = month < 10 ? '0' + month : month;

	var formattedDate = formattedMonth + '-' + formattedDay + '-' + year;

	return formattedDate;
}

function updateCookie(name,properties)
{
  return new Promise((resolve,reject) => {
    setJsonCookie(name,properties,1);
    resolve(properties);
  })
}

function scrollToClass(className, event,is_multi = false,path = '')
{
  event.preventDefault();

  if(is_multi) {
    var elements = document.getElementsByClassName(className);
    var element;

    for (var i = 0; i < elements.length; i++) {
      var currentElement = elements[i];

      if (currentElement.id && currentElement.id.includes(path)) {
          element = currentElement;
          break;
      }
    }

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  } else {
    var elements = document.getElementsByClassName(className);

    if (elements.length > 0) {
      elements[0].scrollIntoView({ behavior: 'smooth' });
    }
  }
}

async function getCartItems() {
  const result = await fetch(cartObj.route.getCart);
  if(result.status === 200) {
    return result.json();
  }

  return {items: []};
}

async function clearCart()
{
  const cart = await getCartItems();

  var totalBundles = 0;

  //Tracking Bundles
  let items = cart.items.reduce((acc, item) => {
    if (item.handle.includes('-bg')) {
      let hasSubscription = item.properties['_bundle_subscription'] ? 'Subscription' : 'One-time';
      acc.push({
        item_id: item.id,
        name: item.product_title,
        discount: 0.00,
        item_brand: "Alen",
        item_category: "Bundles",
        price: (item.price / 100).toFixed(2),
        quantity: item.quantity,
        purchase_type: hasSubscription
      });


      productPrice = item.price * item.quantity;
      totalBundles += parseFloat((productPrice / 100).toFixed(2));
    }
    return acc;
  }, []);

  if(items.length) {
    dataLayer.push({ eventModel: null });

    var ecommAddToCartGA4 = {
      event: "remove_all_from_cart",
      eventModel: {
        currency: "USD",
        ecomm_totalvalue: totalBundles,
        items: items
      }
    };
    console.log("GA4 HD Bundles:",ecommAddToCartGA4);

    dataLayer.push(ecommAddToCartGA4);
  }

  Shopify.analytics.publish("all_products_removed_from_cart", { items: cart?.items });

  removeAllCartCookies()
    .then(res => {
      fetch(cartObj.route.clear, {
        method: 'POST'
      })
        .then(function (response) {
          if (!response.ok) {
            throw response;
          }
          location.reload();
        })
        .catch(function (error) {
          console.log(">>> Delete items from cart ERROR: ", error);
        });
    });
}

function getDiscountedPrice(price, discount)
{
  let toDiscount = (price * discount) / 100;

  let discountedPrice = price - toDiscount;

  discountedPrice = discountedPrice.toFixed(2);

  return discountedPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function getDiscountedAmount(price, discount)
{
  let discountedPrice = price - discount;

  discountedPrice = discountedPrice.toFixed(2);

  return discountedPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function getDiscountedPercentage(price, discount)
{
  let toDiscount = (price * discount) / 100;

  let discountedPrice = price - toDiscount;

  discountedPrice = discountedPrice.toFixed(2);

  return discountedPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function formatPrice(htmlPrice,discount,type)
{
	const normalPrice = parseFloat(htmlPrice.replace(/[^\d.-]/g, ''));
	let discountedPrice = htmlPrice;

	if(type === "%")
		discountedPrice = getDiscountedPercentage(normalPrice,discount);
	else
		discountedPrice = getDiscountedAmount(normalPrice,discount);

	return discountedPrice;
}

function applyPreSaleDiscount(price,discount,type)
{
	let discountedPrice = price;

	if(type === "%")
		discountedPrice = getDiscountedPercentage(price,discount);
	else
		discountedPrice = getDiscountedAmount(price,discount);

	return discountedPrice;
}


function helperCheckProductCards() {
    let interval = setInterval(function() {
        if (global_configs.is75iPreSale) {
            let elCardPrice = document.getElementById("card-normal-price-75i");
            let elCardCompare = document.getElementById("card-compare-at-price-75i");
            let _75iDiscount = global_configs._75iDiscount.split(",");

            if(!elCardCompare && elCardPrice) {
            const newSpan = document.createElement('span');

            newSpan.innerHTML = `<strike id="card-compare-at-price-75i" data-class="is-showing" class="product-price--compared js-product-compare-price compare-price--grid ">${elCardPrice.textContent}</strike>`;
            newSpan.className = 'inline-block mls';

            elCardPrice.parentNode.appendChild(newSpan);
            } else if (elCardPrice) {
            elCardCompare.innerHTML = elCardPrice.textContent;
            }

            if(elCardPrice)
            elCardPrice.innerHTML = `$${formatPrice(elCardPrice.textContent,_75iDiscount[0],_75iDiscount[1])}`;

            clearInterval(interval);
        }

      if (global_configs.is45iPreSale) {
        let elCardPrice = document.getElementById("card-normal-price-45i");
        let elCardCompare = document.getElementById("card-compare-at-price-45i");
        let _45iDiscount = global_configs._45iDiscount.split(",");

        if(!elCardCompare && elCardPrice) {
          const newSpan = document.createElement('span');

          newSpan.innerHTML = `<strike id="card-compare-at-price-45i" data-class="is-showing" class="product-price--compared js-product-compare-price compare-price--grid ">${elCardPrice.textContent}</strike>`;
          newSpan.className = 'inline-block mls';

          elCardPrice.parentNode.appendChild(newSpan);
        } else if (elCardPrice) {
          elCardCompare.innerHTML = elCardPrice.textContent;
        }

        if(elCardPrice)
          elCardPrice.innerHTML = `$${formatPrice(elCardPrice.textContent,_45iDiscount[0],_45iDiscount[1])}`;

        clearInterval(interval);
      }

	  if (global_configs.is35iPreSale) {
        let elCardPrice = document.getElementById("card-normal-price-35i");
        let elCardCompare = document.getElementById("card-compare-at-price-35i");
        let _35iDiscount = global_configs._35iDiscount.split(",");

        if(!elCardCompare && elCardPrice) {
          const newSpan = document.createElement('span');

          newSpan.innerHTML = `<strike id="card-compare-at-price-35i" data-class="is-showing" class="product-price--compared js-product-compare-price compare-price--grid ">${elCardPrice.textContent}</strike>`;
          newSpan.className = 'inline-block mls';

          elCardPrice.parentNode.appendChild(newSpan);
        } else if (elCardPrice) {
          elCardCompare.innerHTML = elCardPrice.textContent;
        }

        if(elCardPrice)
          elCardPrice.innerHTML = `$${formatPrice(elCardPrice.textContent,_35iDiscount[0],_35iDiscount[1])}`;

        clearInterval(interval);
      }

      if (global_configs.isFlexPreSale) {
        let elCardPrice = document.getElementById("card-normal-price-FLEX");
        let elCardCompare = document.getElementById("card-compare-at-price-FLEX");
        let _flexDiscount = global_configs._flexDiscount.split(",");

        if(!elCardCompare && elCardPrice) {
          const newSpan = document.createElement('span');

          newSpan.innerHTML = `<strike id="card-compare-at-price-flex" data-class="is-showing" class="product-price--compared js-product-compare-price compare-price--grid ">${elCardPrice.textContent}</strike>`;
          newSpan.className = 'inline-block mls';

          elCardPrice.parentNode.appendChild(newSpan);
        } else if (elCardPrice) {
          elCardCompare.innerHTML = elCardPrice.textContent;
        }

        if(elCardPrice)
          elCardPrice.innerHTML = `$${formatPrice(elCardPrice.textContent,_flexDiscount[0],_flexDiscount[1])}`;

        clearInterval(interval);
      }
    }, 1000);

  }
function getDiscountedPriceHTML(originalPrice, discountedPrice, elementId = '') {
    const idAttribute = elementId ? `id="${elementId}"` : '';
    return `${discountedPrice} <strike ${idAttribute} style="color:gray;" data-class="is-showing" class="product-price--compared js-product-compare-price inline-block mls compare-price--grid">${originalPrice}</strike>`;
}

// Función helper para mobile
function getMobileDiscountedPriceHTML(originalPrice, discountedPrice) {
    return `<span id="mobile-pdp-normal-price" class="big-text">
					${discountedPrice}
					<strike class="strike-pdp-mobile-price" data-class="is-showing">
						${originalPrice}
					</strike>
				</span>`;
}

function getCompareSectionDiscountedPriceHTML(originalPrice, discountedPrice) {
    return `<span" class="big-text">
					${discountedPrice}
					<strike class="strike-pdp-mobile-price" data-class="is-showing">
						${originalPrice}
					</strike>
				</span>`;
}

function getPreSaleDiscount(productTitle, currentPrice)
{
	if (productTitle.toLowerCase().includes('75i')) {
		discountData = global_configs._75iDiscount.split(",");
	}

	if (productTitle.toLowerCase().includes('45i')) {
		discountData = global_configs._45iDiscount.split(",");
	}

	if (productTitle.toLowerCase().includes('35i')) {
		discountData = global_configs._35iDiscount.split(",");
	}

	return applyPreSaleDiscount(currentPrice,discountData[0],discountData[1]);
}

function capitalizeFirstLetter(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

function isDigiohResultPage() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const source = urlParams.get('source');

  if (source === 'digioh-air-purifier-quiz') {
	const digiohElements = document.querySelectorAll(".digioh-pdp-copy");

	if (digiohElements.length > 0) {
		digiohElements.forEach((element) => {
			element.style.display = 'block';
		})
	}
  }

  return false;
}

const getShopifyId = gid => gid.split('/').pop();

const usStates = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California",
    "Colorado", "Connecticut", "Delaware", "District of Columbia",
    "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana",
    "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
    "Massachusetts", "Michigan", "Minnesota", "Mississippi",
    "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
    "New Jersey", "New Mexico", "New York", "North Carolina",
    "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
    "Rhode Island", "South Carolina", "South Dakota", "Tennessee",
    "Texas", "Utah", "Vermont", "Virginia", "Washington",
    "West Virginia", "Wisconsin", "Wyoming"
];

// Keep modal trigger aria-expanded in sync using theme-owned modal lifecycle events.
document.addEventListener('theme:modal:show', function(event) {
  const trigger = event.detail && event.detail.trigger;
  if (trigger instanceof HTMLElement) {
    trigger.setAttribute('aria-expanded', 'true');
  }
});

document.addEventListener('theme:modal:hide', function(event) {
  const trigger = event.detail && event.detail.trigger;
  if (trigger instanceof HTMLElement) {
    trigger.setAttribute('aria-expanded', 'false');
  }
});